import React from 'react'

import { HeadFC, PageProps, graphql } from 'gatsby'

import FlashCardGrid from '@components/Content/FlashCard/FlashCardGrid'
import Hero from '@components/Content/Hero/Hero'
import PageLinks from '@components/Content/PageLinks/PageLinks'
import Wysiwyg from '@components/Content/Wysiwyg/Wysiwyg'
import Layout from '@components/Layout/Layout'
import Section from '@components/Layout/Section'
import SEO from '@components/SEO/SEO'
import Breadcrumbs from '@components/Woocommerce/Breadcrumbs'

import { BreadcrumbsType } from '@contracts/components/breadcrumbs'
import { FinancePageDataType } from '@contracts/pages/financePage'

import * as styles from './FinancePage.module.scss'

const InfoPage: React.FC<PageProps<FinancePageDataType>> = (props) => {
	const page = props.data.wpPage.financeOptions
	const sectors = props.data.allWpSector.nodes

	const breadcrumbsData: BreadcrumbsType = [
		{
			label: 'Home',
			link: '/',
		},
		{
			label: props.data.wpPage.title,
			link: props.data.wpPage.uri,
		},
	]

	return (
		<Layout background="dark">
			<Hero
				data={page.heroFinance}
				heroClass={styles.heroClass}
				smallTitle={true}
				breadcrumbs={<Breadcrumbs data={breadcrumbsData} theme="dark" />}
			/>

			<Section type="thin">
				<Wysiwyg data={props.data.wpPage.content} />
			</Section>

			<Section hasContainer={false}>
				<FlashCardGrid data={sectors} type="full" />
			</Section>

			<Section hasNoTopPadding={true}>
				<PageLinks data={page.pageLinks} />
			</Section>
		</Layout>
	)
}

export const query = graphql`
	query InfoPageQuery($id: String!) {
		wpPage(id: { eq: $id }) {
			title
			uri
			content
			financeOptions {
				heroFinance {
					title
					content
					image {
						...wpMediaItem
						localFile {
							childImageSharp {
								gatsbyImageData(width: 1920)
							}
						}
					}
					button {
						buttonType
						label
						internalLink {
							... on WpPage {
								uri
							}
							... on WpPost {
								uri
							}
							... on WpSimpleProduct {
								uri
							}
							... on WpVariableProduct {
								uri
							}
						}
						externalLink
					}
				}
				pageLinks {
					pageLinks {
						label
						link {
							... on WpPage {
								link
							}
							... on WpPost {
								link
							}
							... on WpTestimonial {
								link
							}
							... on WpSector {
								link
							}
						}
					}
				}
			}
			...PageSeo
		}
		allWpSector(sort: { dateGmt: ASC }) {
			nodes {
				title
				uri
				sectorOptions {
					card {
						image {
							mimeType
							localFile {
								publicURL
								childImageSharp {
									gatsbyImageData(width: 600)
								}
							}
						}
					}
				}
			}
		}
	}
`

export default InfoPage

export const Head: HeadFC<FinancePageDataType> = (props) => {
	return <SEO data={props.data.wpPage.seo} />
}
